import { isAfter, addMonths, startOfMonth } from 'date-fns'

export const isMonthValid = (selected: Date): boolean => {
    const selectedMonthPlusOne = startOfMonth(addMonths(selected, 1))
    const currentMonth = startOfMonth(new Date())

    return !isAfter(selectedMonthPlusOne, currentMonth)
}
